<template>
  <div class="page-main">

    <!-- NAVBAR (sans hero) -->
    <LandingNavbar />

    <main class="container py-6">
      <div class="row mb-5 text-center">
        <h1 class="fw-bold">Projets de la CNTIPPEE</h1>
        <p class="text-muted">
          Découvrez les projets financés, en cours ou en préparation
          à travers les différentes provinces du Gabon.
        </p>
      </div>

      <div class="row g-4">
        <div
            class="col-lg-4 col-md-6"
            v-for="project in projects"
            :key="project.id"
        >
          <router-link
              :to="`/projets/${project.id}`"
              class="text-decoration-none text-dark"
          >
            <ProjectCard :project="project" />
          </router-link>
        </div>
      </div>
    </main>

  </div>
</template>

<script>


  import LandingNavbar from "../../../components/landing/LandingNavbar.vue";
  import ProjectCard from "../../../components/projects/ProjectCard.vue";
  import {projectsMock} from "../../../mocks/projects.mock";

  export default {
    name: "ProjectsPage",
    components: {
      LandingNavbar,
      ProjectCard,
    },
    data() {
      return {
        projects: [],
      };
    },
    mounted() {
      this.projects = projectsMock;
    },
  };
</script>

